import React, { useEffect } from "react";
import { useHistory, useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { AiOutlineArrowLeft } from "react-icons/ai";
import { fetchUserProfile } from "../../actions/student.action";
import { Loading } from "../../utils/helpers/constants";
import RoundLoader from "../../components/loader/RoundLoader";

export default function StudentProfile() {
  const { id } = useParams();
  const history = useHistory();
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(fetchUserProfile(id));
  }, []);

  const {
    student: {
      studentProfile,
      studentProfileLoading,
      studentAchievements,
      studentAddresses,
      projectsCompleted,
      projectsInProgress,
    },
  } = useSelector(({ studentReducer }) => ({
    student: studentReducer,
  }));

  const studentProfileState = studentProfileLoading === Loading.FETCHING;

  return (
    <div className="">
      <div className="doc_processing_color h-40 px-4 pt-6">
        <AiOutlineArrowLeft
          size={25}
          onClick={() => history.goBack()}
          className="mb-5 cursor-pointer"
        />
        <div className="text-md">
          <span className="text-2xl text-green-800 font-serif font-bold">
            User Profile
          </span>
        </div>
        <div className="text-md">More student information.</div>
      </div>

      <div className="p-4 md:px-20">
        <div className="flex items-cente">
          <img
            className="w-32 h-32 mr-4 rounded"
            src={studentProfile.profileImage}
            alt="profile"
          />
          <div className="">
            <div className="text-gray-400 font-bold">
              {studentProfile.executiveType === null
                ? "Student"
                : studentProfile.executiveType}
            </div>
            <div className="text-gray-900 text-2xl">
              {studentProfile.fullName}
            </div>
          </div>
        </div>

        {!studentProfileState ? (
          <div>
            <div className="flex justify-between mt-10 mb-2">
              <div className="text-gray-400 font-bold">About</div>
            </div>
            <div>{studentProfile.bio}</div>
            <div className="flex justify-between mt-10">
              <div className="text-gray-400 font-bold">Contact</div>
            </div>
            <div className="mt-2">
              {studentAddresses.map((address, index) => {
                return <div key={index}>{address?.locationAddress}</div>;
              })}
              <div>{studentProfile.phoneNumber}</div>
            </div>

            <div className="flex justify-between mt-10">
              <div className="text-gray-400 font-bold">History</div>
            </div>
            <div className="mt-2">{studentProfile.history}</div>

            <div className="flex justify-between mt-10">
              <div className="text-gray-400 font-bold">Achievements</div>
            </div>
            <div className="mt-2">
              {studentAchievements.map((achievement, index) => {
                return <div key={index}>{achievement}</div>;
              })}
            </div>

            <div className="flex justify-between mt-10">
              <div className="text-gray-400 font-bold">Projects Done</div>
            </div>
            <div className="mt-2">
              {projectsCompleted.map((project, index) => {
                return <div key={index}>{project}</div>;
              })}
            </div>

            <div className="flex justify-between mt-10">
              <div className="text-gray-400 font-bold">
                Projects in Progress
              </div>
            </div>
            <div className="mt-2">
              {projectsInProgress.map((project, index) => {
                return <div key={index}>{project}</div>;
              })}
            </div>
          </div>
        ) : (
          <RoundLoader />
        )}
      </div>
    </div>
  );
}
